import React, { useEffect, useState } from 'react';
import TController from './TController';
import { Box } from '@mui/material';
import { PersitedDatePicker } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';
import axios from 'axios';
import ParetoChart from './ParetoChart';
interface IProps {
  apiData: any;
}
const DefectWiseQty = ({ apiData }: IProps) => {
  return (
    <div>
      <TController apiData={apiData} />
      {
        <Box style={{ paddingBottom: '3rem', width: '50vw' }}>
          <ParetoChart apiData={apiData} />
        </Box>
      }
    </div>
  );
};

export default DefectWiseQty;
